'use client'

import React from 'react'
import Link from 'next/link'
import { ArrowUpRight } from 'lucide-react'
import { trackCtaClicked } from '../../lib/analytics'

export function EligibilityAssessmentCTALink() {
  return (
    <Link
      href="/eligibility"
      onClick={() =>
        trackCtaClicked({
          cta_text: 'Start Assessment',
          cta_location: 'eligibility_section',
          destination_url: '/eligibility',
        })
      }
      className="inline-flex text-lg items-center gap-2 px-8 py-3.5 bg-white text-gray-900 rounded-full hover:bg-gray-100 transition-all font-medium"
    >
      Start Assessment
      <ArrowUpRight className="w-5 h-5" />
    </Link>
  )
}
